import React, { useState, useEffect } from "react";
import {
  Layout,
  Menu,
  Button,
  Typography,
  Dropdown,
  Space,
  Drawer,
  Row,
  Col,
} from "antd";
import {
  ShoppingCartOutlined,
  WhatsAppOutlined,
  UserOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { styles } from "./AppHeaderstyle";
import { Link, useLocation } from "react-router-dom";
import nexuslogo from "../image/logonexus.png";

const { Header } = Layout;
const { Text } = Typography;

const currencyMenuItems = [
  { key: "Medicals", label: "Shri Datta Medisales" },
  { key: "Shri Datta Opticals", label: "Shri Datta Opticals" },
];

const AppHeader = () => {
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const Functionscrooll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Layout style={styles.fixheader}>
      <div style={styles.topBar}>
        <Row justify="space-between" align="middle">
          <Col xs={24} sm={12}>
            <Text style={styles.textWhite}>
              Monday - Saturday 9:00 AM - 7:00 PM
            </Text>
          </Col>

          <Col xs={0} sm={12} style={{ textAlign: "right" }}>
            <Space size="small">
              {/* <Dropdown
                menu={{ items: currencyMenuItems }}
                placement="bottomRight"
              >
                <Text style={styles.textWhite} cursor="pointer">
                  FIRM ▼
                </Text>
              </Dropdown> */}
              <Text style={styles.textWhite}> Sunday - </Text>
              <Text style={styles.textWhite}> Call</Text>
            </Space>
          </Col>
        </Row>
      </div>

      <Header style={styles.header}>
        <Row justify="space-between" align="middle">
          {isMobile && (
            <Col xs={4} sm={4}>
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerVisible(true)}
                style={styles.menuButton}
              />
            </Col>
          )}

          {/* <Col xs={16} sm={6} style={{ textAlign: "center" }}>
            <Typography.Title level={3} style={styles.logoText}>
              Shri Datta Opticals
            </Typography.Title>
            <img src={nexuslogo} alt="Nexus Logo" style={styles.logosize} />
          </Col> */}
          <Col
            xs={16}
            sm={6}
            md={6}
            style={{
              textAlign: "center",
              display: "flex",
              justifyContent: isMobile ? "right" : "left",
              alignItems: "center",
            }}
          >
            <Link to="/">
              <img src={nexuslogo} alt="Nexus Logo" style={styles.logosize} />
            </Link>
          </Col>

          {!isMobile && (
            <Col sm={12}>
              {/* <Menu mode="horizontal" theme="dark" style={styles.menu}>
                <Link to="/">
                  <Menu.Item style={styles.menutitle} key="Home">
                    Home
                  </Menu.Item>
                </Link>
                <Link to="/">
                  <Menu.Item style={styles.menutitle} key="pages">
                    Gallery
                  </Menu.Item>
                </Link>
                <Link to="/">
                  <Menu.Item style={styles.menutitle} key="products">
                    Products
                  </Menu.Item>
                </Link>
                <Link to="/contact">
                  <Menu.Item style={styles.menutitle} key="contact">
                    Contact
                  </Menu.Item>
                </Link>
              </Menu> */}
              <Menu
                mode="horizontal"
                // theme="dark"
                style={styles.menu}
                selectedKeys={[location.pathname]} // ✅ Track active menu
              >
                <Menu.Item
                  key="/"
                  style={styles.menutitle}
                  onClick={Functionscrooll}
                >
                  <Link to="/">Home</Link>
                </Menu.Item>
                <Menu.Item
                  key="/Aboutus"
                  style={styles.menutitle}
                  onClick={Functionscrooll}
                >
                  <Link to="/Aboutus">About Us</Link>
                </Menu.Item>
                <Menu.Item
                  key="/products"
                  style={styles.menutitle}
                  onClick={Functionscrooll}
                >
                  <Link to="/services">Services</Link>
                </Menu.Item>
                <Menu.Item
                  key="/gallery"
                  style={styles.menutitle}
                  onClick={Functionscrooll}
                >
                  <Link to="/gallery">Gallery</Link>
                </Menu.Item>
                <Menu.Item
                  key="/contact"
                  style={styles.menutitle}
                  onClick={Functionscrooll}
                >
                  <Link to="/contact">Contact</Link>
                </Menu.Item>
              </Menu>
            </Col>
          )}

          {!isMobile && (
            <Col sm={6} style={{ textAlign: "right" }}>
              <Space size="middle">
                <a href="tel:+919284382353">
                  <Button shape="circle" icon={<UserOutlined />} />
                </a>
                <a
                  href="https://wa.me/9284382353"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button shape="circle" icon={<WhatsAppOutlined />} />
                </a>
                {/* <Text style={styles.textWhite}>$0.00</Text> */}
              </Space>
            </Col>
          )}
        </Row>
      </Header>

      {isMobile && (
        <Drawer
          title="Menu"
          placement="left"
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          width={239}
          closeIcon={
            <span style={{ color: "white", fontSize: "18px" }}>✖</span>
          }
          drawerStyle={{
            background:
              "linear-gradient(90deg, rgb(3, 13, 51), rgb(0, 53, 55), rgb(0 0 0))",
            color: "white",
          }}
        >
          <Menu
            mode="vertical"
            selectedKeys={[location.pathname]}
            style={{ background: "transparent", color: "white" }}
          >
            {[
              { key: "/", label: "Home" },
              { key: "/Aboutus", label: "About Us" },
              { key: "/services", label: "Services" },
              { key: "/gallery", label: "Gallery" },
              { key: "/contact", label: "Contact" },
            ].map((item) => (
              <Menu.Item
                key={item.key}
                onClick={() => {
                  setDrawerVisible(false);
                  window.scrollTo({ top: 0, behavior: "smooth" }); // Scroll to top
                }}
                style={{
                  color: location.pathname === item.key ? "#FFD700" : "white", // Highlight active menu
                  backgroundColor:
                    location.pathname === item.key
                      ? "rgba(255, 255, 255, 0.2)"
                      : "transparent",
                  borderRadius: "4px",
                }}
              >
                <Link to={item.key} style={{ color: "inherit" }}>
                  {item.label}
                </Link>
              </Menu.Item>
            ))}
          </Menu>
        </Drawer>
      )}
    </Layout>
  );
};

export default AppHeader;
